import React from 'react';
import { Route, Switch, HashRouter as Router } from 'react-router-dom';

import Home from './Home';
import WhereToGetCare from './WhereToGetCare';
import WellnessResources from './WellnessResoures';

// Benefits
import Medical from 'Views/benefits/Medical';
import Pharmacy from 'Views/benefits/Pharmacy';
import Dental from 'Views/benefits/Dental';
import Vision from 'Views/benefits/Vision';
import LifeDisability from 'Views/benefits/LifeDisability';
import Voluntary from 'Views/benefits/Voluntary';
import HowPlanWorks from 'Views/benefits/HowPlanWorks';
import MoreMaterials from 'Views/benefits/MoreMaterials';
import BenefitDetail from 'Views/benefits/BenefitDetails';
import VaInOut from 'Views/benefits/VaInOut';

export default class AppRouter extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/benefits/medical" component={Medical} />
        <Route path="/benefits/pharmacy" component={Pharmacy} />
        <Route path="/benefits/dental" component={Dental} />
        <Route path="/benefits/vision" component={Vision} />
        <Route path="/benefits/life-disability" component={LifeDisability} />
        <Route path="/benefits/voluntary" component={Voluntary} />
        <Route path="/benefits/how-plan-works" component={HowPlanWorks} />
        <Route path="/benefits/more-materials" component={MoreMaterials} />
        <Route path="/benefits/benefit-details" component={BenefitDetail} />
        <Route path="/benefits/vaInOut" component={VaInOut} />
        <Route path="/where-to-get-care" component={WhereToGetCare} />
        <Route path="/wellness-resources" component={WellnessResources} />
      </Switch>
    );
  }
}
